import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import AddressSection from "./components/AddressSection";
import AppSection from "./components/AppSection";
import GuideSection from "./components/GuideSection";
import StatusSection from "./components/StatusSection";
import CompareSection from "./components/CompareSection";
import LogSection from "./components/LogSection";
import SecuritySection from "./components/SecuritySection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <TopNav />
      <main>
        <Hero />
        <AddressSection />
        <AppSection />
        <GuideSection />
        <StatusSection />
        <CompareSection />
        <LogSection />
        <SecuritySection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}